import { BMButton, BMPopup, BMText } from "@traveloka/district-bloom";
import { useMemo } from "react";
import BMView from "../../../../../components/View/BMView";
import { useMobileContentResource } from "../../../../../core/resource/MobileResourceProvider";
import { formatMessage } from "../../../../../utils";

type BaseErrorModalProps = {
  visible?: boolean;
  onClose?: () => void;
};

type SpecificErrorProps = BaseErrorModalProps & {
  variant?: "SOLD_OUT" | "INSUFFICIENT_CREDIT" | "BOOKING_SPEC_NOT_ALLOWED";
};

type GenericErrorProps = BaseErrorModalProps & {
  variant: "GENERIC_ERROR";
  error?: string;
};

type Props = SpecificErrorProps | GenericErrorProps;

export default function SoldOutModal({
  visible = true,
  onClose = () => {},
  ...props
}: Props) {
  const { CorporateFlightPrebookForm: cr, CorporateCommon: crc } =
    useMobileContentResource();

  const content = useMemo(() => {
    switch (props.variant) {
      case "SOLD_OUT":
        return {
          title: cr.submitFlightSoldOutErrorModalTitle,
          description: cr.submitFlightSoldOutErrorModalDescription,
          button: cr.submitErrorSelectAnotherFlightCta,
        };
      case "INSUFFICIENT_CREDIT":
        return {
          title: cr.submitInsufficientCreditErrorModalTitle,
          description: cr.submitInsufficientCreditErrorModalDescription,
          button: crc.backToHomeText,
        };
      case "GENERIC_ERROR": {
        return {
          title: cr.submitGenericErrorModalTitle,
          description: formatMessage(cr.submitGenericErrorModalDescription, {
            enum: props.error || "undefined",
          }),
          button: crc.backToHomeText,
        };
      }
      default:
        return {
          title: cr.submitGenericErrorModalTitle,
          description: formatMessage(cr.submitGenericErrorModalDescription, {
            enum: props.variant || "undefined",
          }),
          button: cr.submitErrorSelectAnotherFlightCta,
        };
    }
  }, [props.variant, cr, crc]);

  return (
    <BMPopup
      dismissible={false}
      isVisible={visible}
      onPopupClose={() => {}} // Disable default close on overlay press because dismissible is false
      title={content.title}
    >
      <BMView spacing="lg">
        <BMText variant="paragraphNormal">{content.description}</BMText>
        <BMButton
          size="LARGE"
          stretchable
          onPress={onClose}
          label={content.button}
        />
      </BMView>
    </BMPopup>
  );
}
